import { css } from '@emotion/react';
const animations = css `
  @keyframes ga-opacity {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 0.75;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      color: 0.75;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes bounce {
    from {
      transform: translateY(-5px);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes horizontal-bounce {
    0% {
      transform: translateY(0);
    }
    70% {
      transform: translateX(10px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes fade-in-to-top-small {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fade-in-to-top {
    from {
      opacity: 0;
      transform: translateY(100px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fade-out-to-bottom {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(100px);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes fade-in-with-scale {
    0% {
      opacity: 0.7;
      transform: scale(0.7);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes appear-from-right {
    0% {
      right: -100%;
    }
    100% {
      right: 0;
    }
  }

  @keyframes hide-to-right {
    0% {
      right: 0;
    }
    100% {
      right: -100%;
    }
  }

  @keyframes appear-from-left {
    0% {
      left: -100%;
    }
    100% {
      left: 0;
    }
  }

  @keyframes hide-to-left {
    0% {
      left: 0;
    }
    100% {
      left: -100%;
    }
  }

  @keyframes up-down-medium {
    0% {
      top: 0;
    }
    40% {
      top: -90px;
    }
    75% {
      top: -90px;
    }
    100% {
      top: 0;
    }
  }

  @keyframes scale-in-out {
    0% {
      transform: scale(1.5);
    }
    75% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;
export default animations;
//# sourceMappingURL=animations.js.map